import { useState, useEffect } from 'react'

export function useFetch(url, headers) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    setLoading(true)
    setData(null)
    setError(null)
    fetch(url, {
      headers,
    })
      .then((rsp) => rsp.json())
      .then((rsp) => {
        setLoading(false)
        setData(rsp)
      })
      .catch((err) => {
        setLoading(false)
        setError(err.toString())
      })
      .finally(() => setLoading(false))
  }, [url, headers])

  return { data, loading, error }
}

export function useFetchWithToken(url, tokenGetter) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    setLoading(true)
    ;(async () => {
      try {
        const token = await tokenGetter()
        const rsp = await fetch(url, {
          headers: { Authorization: `Bearer ${token}` },
        })
        const json = await rsp.json()
        setLoading(false)
        setData(json)
      } catch (error) {
        setLoading(false)
        setError(error.toString())
      } finally {
        setLoading(false)
      }
    })()
  }, [url, tokenGetter])

  return { data, loading, error }
}

// export function usePostWithToken(url, body, tokenGetter) {
//   const [data, setData] = useState(null)
//   const [loading, setLoading] = useState(false)
//   const [error, setError] = useState(null)

//   useEffect(() => {
//     setLoading(true)
//     ;(async () => {
//       try {
//         const token = await tokenGetter()
//         const rsp = await fetch(
//           url,
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           },
//           body
//         )
//         const json = await rsp.json()
//         setLoading(false)
//         setData(json)
//       } catch (error) {
//         setLoading(false)
//         setError(error)
//       } finally {
//         setLoading(false)
//       }
//     })()
//   }, [url, tokenGetter])

//   return { data, loading, error }
// }
